/** @format */
import {
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAILURE,
} from "./FetchUserInventoryTypes";

const initialState = {
  loading: false,
  inventoryData: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVENTORY_SUCCESS:
      return {
        loading: false,
        inventoryData: action.payload,
        error: "",
      };
    case FETCH_INVENTORY_FAILURE:
      return {
        loading: false,
        inventoryData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
